import { Field, Form, useFormikContext } from 'formik';
import { FileRejection } from 'react-dropzone';

import { useTranslation } from '@packlink/translation-provider';
import { FormField, Input } from '@shipengine/formik-giger';
import {
    getDisabledFieldSetStyles,
    getFieldStyles,
    getImageUploaderStyles,
    getSubtitleStyles,
    getTitleStyles,
} from './BrandSettingsFormStyles';
import { Button, ButtonSize, Next, Typography } from '@shipengine/giger';
import { FormFields } from '../BrandedEmailsSettings/BrandSettings';

interface BrandSettingsFormProps {
    isFormDisabled?: boolean;
}

export function BrandSettingsForm({ isFormDisabled }: BrandSettingsFormProps): JSX.Element {
    const { t } = useTranslation();
    const { errors, values, setFieldTouched, handleChange, isSubmitting } = useFormikContext<FormFields>();

    const handleOnChange = async (acceptedFiles: File[], rejectedFiles: FileRejection[]) => {
        const file = acceptedFiles.length ? acceptedFiles[0] : rejectedFiles[0]?.file;

        setFieldTouched('companyLogo', true);
        handleChange({ target: { name: 'companyLogo', value: file } });
    };

    return (
        <Form css={isFormDisabled ? getDisabledFieldSetStyles : undefined}>
            {!isFormDisabled && (
                <Typography css={getSubtitleStyles} variant="body2" component="p">
                    {t('brand-settings.form.description')}
                </Typography>
            )}

            <Typography variant="heading6" component="h3" bold css={getTitleStyles}>
                {t('brand-settings.form.store-information')}
            </Typography>

            <Typography css={getSubtitleStyles} variant="body2" component="p">
                {t('brand-settings.form.email-optional')}
            </Typography>

            <FormField name="companyReplyToEmail">
                <Field
                    css={getFieldStyles}
                    disabled={isFormDisabled}
                    component={Input}
                    label={t('form.label.store-email')}
                />
            </FormField>
            <Typography css={getSubtitleStyles} variant="body2" component="p">
                {t('brand-settings.form.company')}
            </Typography>
            <FormField name="companyName">
                <Field
                    css={getFieldStyles}
                    disabled={isFormDisabled}
                    component={Input}
                    label={t('form.label.company-name')}
                />
            </FormField>

            <Typography variant="heading6" component="h3" bold css={getTitleStyles}>
                {t('brand-settings.form.add-logo-optional')}
            </Typography>
            <Typography css={getSubtitleStyles} variant="body2" component="p">
                {t('brand-settings.logo.info')}
            </Typography>
            <FormField name="companyLogo">
                <Next.ImageUploader
                    disabled={isFormDisabled}
                    accept={{
                        'image/jpeg': ['.jpeg', '.jpg'],
                        'image/png': ['.png'],
                    }}
                    css={[getImageUploaderStyles, getFieldStyles]}
                    labels={{
                        toUpload: t('image-uploader.button.upload-image'),
                        toDrag: t('image-uploader.info.drop-image'),
                        toDrop: t('image-uploader.info.drop-image'),
                        toRemove: t('image-uploader.button.remove'),
                    }}
                    image={!errors.companyLogo ? values.companyLogo : undefined}
                    onChange={handleOnChange}
                />
            </FormField>
            <Button size={ButtonSize.SMALL} type="submit" isLoading={isSubmitting} disabled={isFormDisabled}>
                {t('branded-emails.header.save')}
            </Button>
        </Form>
    );
}
